import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const TemplatesService = {
  addTemplateMailing: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}mailing/templates`, data);
  },
  editTemplateMailing: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}mailing/templates`, data);
  },
  deleteTemplateMailing: (id: string) => {
    return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}mailing/templates/${id}`);
  },
  getAllTemplatesMailing: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}mailing/templates`);
  },
  getTemplatesAccountMailing: (id: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}mailing/templates/${id}`);
  },
  changeStatusTemplatesMailing: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}mailing/templates/status`, data);
  },
  addTemplateRCS: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}rcs/templates`, data);
  },
  editTemplateRCS: (data: any) => {
    return HTTP.put<any, any>(`${API_ENDPOINT.CORE}rcs/templates`, data);
  },
  getAllTemplatesRCS: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}rcs/templates`);
  },
  getTemplatesAccountRCS: (account: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}rcs/templates`, {
      params: {
        account: account
      }
    });
  },
  changeStatusTemplatesRCS: (id: string, data: { status: boolean }) => {
    return HTTP.patch<any, any>(`${API_ENDPOINT.CORE}rcs/templates/${id}/status`, data);
  },
  deleteTemplateRCS: (id: string) => {
    return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}rcs/templates/${id}`);
  },
  deleteTemplateWa: (body: { template: string }) => {
    return HTTP.delete(`${API_ENDPOINT.CORE}whatsapp/templates`, { data: body });
  },
  addTemplateWa: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}whatsapp/templates`, data);
  },
  uploadMediaTemplateWa: (data: any) => {
    return HTTP.post<any, any>(`${API_ENDPOINT.CORE}whatsapp/templates/media`, data);
  },
  getAllTemplatesWa: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}whatsapp/templates`);
  },
  getTemplatesAccountWa: (id: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}whatsapp/templates/${id}`);
  }
};
